/* Render the current metafield, including after a Shopify variant change. */
(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (!root || !root.customElements || root.customElements.get('ss-nutrition-table')) return;
  class NutritionTable extends HTMLElement {
    connectedCallback() {
      if (this.dataset.rendered) return;
      var source = this.querySelector('[data-nutrition-source]');
      if (!source) return;
      var paragraphs = Array.from(source.querySelectorAll('p,li,h2,h3,h4'));
      var parsed = api.parse(paragraphs.length ? paragraphs.map(function (p) { return p.textContent; }).join('\n') : source.textContent);
      if (!parsed.groups.length) return; // Keep incomplete declarations and warnings visible.
      var result = document.createElement('div');
      parsed.groups.forEach(function (group) {
        var table = document.createElement('table');
        table.className = 'ss-nutrition-table';
        var caption = table.createCaption(); caption.textContent = group.caption;
        var header = table.createTHead().insertRow();
        ['Nährwert', 'Menge'].forEach(function (label) { var th = document.createElement('th'); th.scope = 'col'; th.textContent = label; header.appendChild(th); });
        var body = table.createTBody();
        group.rows.forEach(function (row) {
          var tr = body.insertRow(); var th = document.createElement('th'); th.scope = 'row'; th.textContent = row.label; tr.appendChild(th);
          tr.insertCell().textContent = row.value;
        });
        result.appendChild(table);
      });
      parsed.notes.forEach(function (note) { var p = document.createElement('p'); p.textContent = note; result.appendChild(p); });
      this.appendChild(result); source.hidden = true; this.dataset.rendered = 'true';
    }
  }
  root.customElements.define('ss-nutrition-table', NutritionTable);
})(typeof window === 'undefined' ? null : window, function () {
  'use strict';
  function parse(input) {
    var text = String(input || '').replace(/\u00a0/g, ' ');
    var number = '(?:[<>≤≥]\\s*)?[0-9]+(?:[ .,][0-9]+)*';
    var quantity = number + '\\s*(?:kcal|kj|gr\\.?|g|mg|µg|ml)(?![a-z])';
    var labels = '(?:davon\\s*:?\\s*)?gesättigte\\s+(?:Fettsäuren|fettäuren)|(?:davon\\s*:?\\s*)?Zucker|Brennwert|Energie|Kohlenhydrate|Ballaststoffe|Eiweiß|Eiweiss|Protein|Fett|Salz';
    var rx = new RegExp('(' + labels + ')\\s*:?\\s*(' + quantity + '(?:\\s*[/|]?\\s*' + quantity + ')?)', 'gi');
    var groups = [], notes = [], previousEnd = 0, group;
    var matches = Array.from(text.matchAll(rx));
    matches.forEach(function (m) {
      var rawLabel = m[1].toLowerCase();
      var label = /brennwert|energie/.test(rawLabel) ? 'Energie' : /gesättigte/.test(rawLabel) ? 'davon gesättigte Fettsäuren' : /zucker/.test(rawLabel) ? 'davon Zucker' : /eiweiß|eiweiss|protein/.test(rawLabel) ? 'Eiweiß' : m[1].charAt(0).toUpperCase() + m[1].slice(1);
      var between = text.slice(previousEnd, m.index).trim().replace(/^[;.\s]+|[;:\s]+$/g, '');
      if (!group || group.rows.some(function (r) { return r.label === label; })) {
        var caption = between.replace(/^(?:Durchschnittliche\s+)?Nährwert(?:angaben|e)\s*/i, '').trim();
        var basis = caption.match(/(?:je|pro)\s+100\s*(?:g|ml)\b/i);
        if (basis && !/Cookie|Portion|Croissant|Schoko|Vanille/i.test(caption)) caption = 'Durchschnittliche Nährwerte ' + basis[0];
        group = {caption: caption || 'Nährwertangaben', rows: []}; groups.push(group);
      } else if (between.replace(/[.;:\s]/g, '')) notes.push(between);
      group.rows.push({label: label, value: m[2].replace(/\s+/g, ' ').trim()});
      previousEnd = m.index + m[0].length;
    });
    var tail = text.slice(previousEnd).replace(/^[;.\s]+/, '').trim();
    if (tail) notes.push(tail);
    var order = ['Energie','Fett','davon gesättigte Fettsäuren','Kohlenhydrate','davon Zucker','Ballaststoffe','Eiweiß','Salz'];
    groups.forEach(function (g) { g.rows.sort(function (a,b) { return order.indexOf(a.label)-order.indexOf(b.label); }); });
    return {groups:groups, notes:notes};
  }
  return {parse:parse};
});
